import { Permissions } from '@lanterds/types';
import { baseUrl, genericNetworkErrorHandler } from '.';
import { AuthRequest, Method } from 'src/util/Request';

export const getCustomersByPermission = async (permission: Permissions) => {
    const res = await AuthRequest(`${baseUrl}/customers/${permission}`, Method.GET);

    if (res.ok) {
        const customers = await res.json();
        return customers;
    } else {
        await genericNetworkErrorHandler(res);
    }
};
